import { StyleSheet } from '@react-pdf/renderer';

export const reportStyles = StyleSheet.create({
  page: {
    padding: 30,
    fontFamily: 'Helvetica'
  },
  header: {
    fontSize: 18,
    marginBottom: 20,
    textAlign: 'center',
    fontWeight: 'bold'
  },
  table: {
    width: "100%",
    borderStyle: "solid",
    borderWidth: 1,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    flexDirection: "row"
  },
  tableColHeader: {
    width: "10%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    padding: 5,
    backgroundColor: '#f0f0f0',
    alignItems: 'center'
  },
  tableFirstColHeader: {
    width: "90%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    padding: 5,
    backgroundColor: '#f0f0f0'
  },
  tableCol: {
    width: "10%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    fontSize: 10,
    padding: 5,
    alignItems: 'center'
  },
  tableFirstCol: {
    width: "90%",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderRightWidth: 1,
    fontSize: 10,
    padding: 5
  },
  headerText: {
    fontWeight: 'bold',
    fontSize: 12
  },
  legendText: {
    fontSize: 10,
    color: 'gray'
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 0,
    right: 0,
    textAlign: 'center',
    fontSize: 10,
    color: 'gray'
  }
});